var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.356 8.336c.4 0 .915.326.915.727v6.819c0 1.205-.97 2.181-2.166 2.181H2.167A2.174 2.174 0 0 1 0 15.882V9.063c0-.401.402-.727.8-.727.4 0 .723.326.723.727l-.004 6.619c0 .401.324.727.723.727h10.666a.725.725 0 0 0 .723-.727l.003-6.619c0-.401.324-.727.722-.727zM8.082.213l2.89 2.91c.281.283.288.807.006 1.091a.719.719 0 0 1-1.021 0L8.363 2.609v8.636c0 .402-.386.727-.784.727-.4 0-.773-.325-.773-.727V2.596L5.2 4.214a.719.719 0 0 1-1.021 0c-.282-.284-.289-.808-.007-1.092L7.061.213a.719.719 0 0 1 1.021 0z",
    id: "share"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#222B45",
    xlinkHref: "#share",
    transform: "translate(4.421 2.937)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.45010ba3.svg";
export { ForwardRef as ReactComponent };